import styled from "styled-components";

export const Content = styled.div`
	display: flex;
	flex-direction: column;
	gap: 25px;
	background: ${({ theme }) => theme.grayLight};
	padding: 15px;
	margin-bottom: 20px;
`;

export const ContainerButton = styled.div`
	display: flex;
	gap: 10px;
	justify-content: center;

	button {
		padding: 5px 15px;
		min-width: 100px;
		background: transparent;
	}

	@media (max-width: 768px) {
		flex-direction: column-reverse;

		button {
			width: 100%;
			max-width: 100%;
			padding: 0.4rem 0 !important;
			margin: 0;
		}
	}
`;
